var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { createTaroSwitchEvent } from '../_util/taroEvent';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
import useMergedState from '../_util/hooks/useMergedState';
import useField from '../form/useField';
const Switch = (_a) => {
    var { style, className, name, checked, type = 'switch', color = '#04be02', disabled = false, onChange } = _a, rest = __rest(_a, ["style", "className", "name", "checked", "type", "color", "disabled", "onChange"]);
    const props = useTaroBaseEvents(rest);
    const [mergedChecked, setMergedChecked] = useMergedState(false, {
        value: checked
    });
    useField(name, mergedChecked);
    const checkedStyle = mergedChecked
        ? {
            borderColor: color
        }
        : {};
    const mergedStyle = Object.assign(checkedStyle, style);
    return (_jsx("input", Object.assign({ type: 'checkbox', className: classNames({
            'weui-switch': type === 'switch',
            'weui-agree__checkbox': type === 'checkbox'
        }, className), style: mergedStyle, checked: mergedChecked, name: name, disabled: disabled, onChange: event => {
            setMergedChecked(event.target.checked);
            if (onChange) {
                const taroEvent = createTaroSwitchEvent(event);
                onChange(taroEvent);
            }
        } }, props)));
};
export default Switch;
